import { render, staticRenderFns } from "./DeleteWarningModal.vue?vue&type=template&id=b0eed0d0&"
import script from "./DeleteWarningModal.vue?vue&type=script&lang=js&"
export * from "./DeleteWarningModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports